/* Rekover v15 : parallaxe de l'accueil, packs, quiz produit */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Parallaxe de la grande photo ---------- */
  function initParallax() {
    var el = document.querySelector('[data-parallax]');
    if (!el || reduce) return;
    var ticking = false;
    function update() {
      var rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        el.style.transform = 'translate3d(0,' + Math.round(-rect.top * 0.18) + 'px,0)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Packs : ajoute les deux produits d'un coup ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pack-add]');
    if (!btn) return;
    var ids = btn.getAttribute('data-pack-add').split(',');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (window.rkCartRefresh) return window.rkCartRefresh(true);
        location.href = root + 'cart';
      })
      .catch(function () { location.href = root + 'cart'; })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- Quiz produit ---------- */
  var MAP = {
    z_legs: { b_low: 'p_ball', b_mid: 'p_calf', b_high: 'p_boots' },
    z_knee: { b_low: 'p_knee', b_mid: 'p_knee', b_high: 'p_knee' },
    z_back: { b_low: 'p_mat', b_mid: 'p_neck', b_high: 'p_gun' },
    z_feet: { b_low: 'p_ball', b_mid: 'p_feet', b_high: 'p_feet' },
    z_all:  { b_low: 'p_scraper', b_mid: 'p_gun', b_high: 'p_boots' }
  };
  var FALLBACK = ['p_calf', 'p_gun', 'p_neck', 'p_ball'];

  function initQuiz(scope) {
    (scope || document).querySelectorAll('[data-quiz]').forEach(function (quiz) {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = '1';
      var answers = {};
      var steps = quiz.querySelectorAll('[data-step]');
      var bar = quiz.querySelector('[data-quiz-bar]');
      var current = 1;

      function show(n) {
        current = n;
        steps.forEach(function (s) {
          var on = parseInt(s.dataset.step, 10) === n;
          s.hidden = !on;
          s.classList.toggle('is-active', on);
        });
        if (bar) bar.style.width = Math.min(n - 1, 3) / 3 * 100 + '%';
      }

      function result() {
        var key = (MAP[answers.zone] || {})[answers.budget];
        var el = key && quiz.querySelector('[data-result="' + key + '"]');
        for (var i = 0; !el && i < FALLBACK.length; i++) el = quiz.querySelector('[data-result="' + FALLBACK[i] + '"]');
        quiz.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = r !== el; });
        show(4);
      }

      quiz.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-answer]');
        if (opt) {
          answers[opt.dataset.answer] = opt.dataset.value;
          opt.parentElement.querySelectorAll('[data-answer]').forEach(function (o) { o.classList.toggle('is-picked', o === opt); });
          if (current < 3) show(current + 1); else result();
          return;
        }
        if (e.target.closest('[data-quiz-back]') && current > 1) { show(current - 1); return; }
        if (e.target.closest('[data-quiz-restart]')) { answers = {}; quiz.querySelectorAll('.is-picked').forEach(function (o) { o.classList.remove('is-picked'); }); show(1); }
      });
      show(1);
    });
  }

  function start() { initParallax(); initQuiz(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { initQuiz(e.target); });
})();
